import React from 'react';
import styled from 'styled-components';

const DataCardWrap = styled.div`
    padding: 12px 16px 12px;
    height: 220px;
    background: #fff;
    border-radius: 4px;

    .udesk-qa-web-coach-evaluation-overview-card-title {
        color: rgba(0, 0, 0, 0.85);
        font-weight: 500;
        font-size: 14px;
        line-height: 22px;
        margin-bottom: 16px;
    }
    .udesk-qa-web-coach-evaluation-overview-card-content {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        height: calc(100% - 38px);

        .udesk-qa-ui-divider-vertical {
            height: 24px;
        }
        .udesk-qa-ui-space {
            width: 100%;
            .udesk-qa-ui-space-item {
                flex: 1;
                .udesk-qa-web-coach-evaluation-overview-card-content-item {
                    text-align: center;
                    width: 100%;
                    .udesk-qa-web-coach-evaluation-overview-card-content-item-count {
                        font-weight: 500;
                        font-size: 40px;
                        line-height: 48px;
                        color: #1a6eff;
                        margin-bottom: 4px;
                    }
                }
            }
        }
    }
`;

export const DataCard: React.FC<{
    title: string;
    children: React.ReactNode;
    className?: string;
}> = ({ title, children, className }) => (
    <DataCardWrap className={`udesk-qa-web-coach-evaluation-overview-card ${className || ''}`}>
        <div className="udesk-qa-web-coach-evaluation-overview-card-title">{title}</div>
        {children}
    </DataCardWrap>
);
